import React, { useContext, useEffect, useState } from "react";
import {
    createPlain,
    getTeaSignIn,
    getTeaSignInList,
    SignInDetail
} from "service/signIn";
import ProjectionModal from "../../../ProjectionModal";
import { useHistory } from "react-router-dom";
import useRequest from "utils/useRequest";
import ResultMessage from "components/CourseComponents/ResultMessage";
import { errorMessage, toNumber } from "service/service";
import style from "./index.module.scss";
import { Spin } from "antd";
import ListItem from "components/CourseComponents/SignIn/ListItem";
import SettingModal from "components/CourseComponents/SignIn/SettingModal";
import qs from "qs";
import { CourseContext, resourceModalAtom } from "../../../../Store";
import CourseButton from "components/CourseComponents/CourseButton";
import CustomEmpty from "components/CourseComponents/CustomEmpty";
import useChannel from "utils/useChannel";
import { useAtom } from "jotai";

export interface SignInMessage {
    type: "onEnd";
    signInId: number;
}

export default function SignInModal() {
    const history = useHistory();

    const { course, basename } = useContext(CourseContext);
    const [resourceModalState, setResourceModalState] =
        useAtom(resourceModalAtom);
    const [data, { loading }, reload] = useRequest(
        () => getTeaSignInList(course.weekTimeId),
        { autoStart: false },
        [course.weekTimeId]
    );
    const [showModal, setShowModal] = useState(false);
    const [signInDetail, setSignInDetail] = useState<SignInDetail | null>(null);
    const channel = useChannel<SignInMessage>("signIn");

    // 每次打开弹出层都刷新列表数据
    useEffect(() => {
        if (resourceModalState !== "signIn") return;
        reload();
    }, [resourceModalState]);

    async function getSignInData(signInId: number) {
        try {
            const res = await getTeaSignIn(signInId);
            setSignInDetail(res);
            setShowModal(true);
        } catch (e) {
            ResultMessage.error(errorMessage(e, "获取活动信息失败！"));
        }
    }

    function addNewSignIn() {
        setSignInDetail(null);
        setShowModal(true);
    }

    // 立即开始普通签到
    async function startPlainTask(signId: number) {
        await createPlain(signId);
        gotoDetail(signId);
    }

    function gotoDetail(id: number, params?: StringMap) {
        const query = qs.stringify({ id, ...params });
        history.replace(`${basename}/sign?${query}`);
        setResourceModalState(null);
    }

    function onEnd(signInId: number) {
        channel.send({ type: "onEnd", signInId });
    }

    return (
        <ProjectionModal
            title="签到活动"
            visible={resourceModalState === "signIn"}
            onCancel={() => setResourceModalState(null)}>
            <div className={style.root}>
                <div className={style.header}>
                    <div className={style.count}>
                        签到活动（{data?.length || 0}）
                    </div>

                    <CourseButton type="add" onClick={addNewSignIn}>
                        添加
                    </CourseButton>
                </div>

                <Spin spinning={loading}>
                    {data?.map(item => (
                        <ListItem
                            key={item.id}
                            weekTimeId={course.weekTimeId}
                            basename={basename}
                            data={item}
                            onDelSuccess={reload}
                            onEdit={() => getSignInData(item.id)}
                            onEnd={() => onEnd(item.id)}
                            gotoDetail={gotoDetail}
                            mode="projection"
                        />
                    ))}

                    {toNumber(data?.length) === 0 && (
                        <CustomEmpty style={{ padding: "100px 0" }} />
                    )}
                </Spin>

                <SettingModal
                    visible={showModal}
                    onClose={() => setShowModal(false)}
                    onStart={startPlainTask}
                    onSuccess={reload}
                    weekTimeId={course.weekTimeId}
                    defaultData={signInDetail}
                    mode="projection"
                />
            </div>
        </ProjectionModal>
    );
}
